{
  "fr": {
    "title": {
      "locations": {
        "index": "Lieux",
        "places": "Tous les lieux"
      },
      "default": "FleetYards.net",
      "defaultShort": "FleetYards",
      "defaultAdmin": "FleetYards.net Command",
      "defaultAdminShort": "FltYrds Command",
      "defaultDocs": "FleetYards.net Documentation",
      "defaultDocsShort": "FleetYards Docs",
      "home": "Accueil",
      "ships": {
        "index": "Vaisseaux",
        "viewer": "Ship Viewer"
      },
      "ship": "%{name} - %{manufacturer}",
      "shipImages": "Images de %{name}",
      "shipVideos": "Vidéos de %{name}",
      "shipHistory": "Historique du %{name}",
      "componentHistory": "Historique de %{name}",
      "shipViewer": "%{name} Viewer",
      "images": "Images",
      "stats": "Statistiques",
      "login": "Se connecter",
      "signUp": "S'inscrire",
      "embed": "Widget Intégré",
      "apiV1": "API V1",
      "apiV1Schema": "Schéma",
      "apiV1Pagination": "Pagination",
      "authApiV1": "Auth API V1",
      "authApiV1OpenId": "OpenID Connect",
      "authApiV1Schema": "Schéma",
      "hangar": {
        "index": "Mon Hangar",
        "preview": "Aperçu de mon Hangar",
        "stats": "Mes statistiques de Hangar",
        "import": "Importer",
        "public": "Hangar de %{user}",
        "publicStats": "Statistiques du Hangar de %{user}",
        "wishlist": "Liste de souhait",
        "publicWishlist": "%{user} Liste de souhait",
        "vehicleLoadouts": "Loadouts du vaisseau",
        "inventories": "My Hangar Inventories",
        "inventory": "%{inventory}",
        "vehicleCargo": "Cargaison du vaisseau",
        "imports": "Imports",
        "transfers": "Transferts"
      },
      "requestPassword": "Demander un mot de passe",
      "changePassword": "Modifier le mot de passe",
      "fleets": {
        "add": "Créer une nouvelle flotte",
        "preview": "Aperçu de la flotte",
        "invites": "Invitations",
        "members": {
          "index": "%{fleet} Members",
          "invites": "%{fleet} Invites",
          "worldmap": "Carte du monde des membres de %{fleet}",
          "starmap": "Carte stellaire des membres de %{fleet}"
        },
        "squadrons": {
          "index": "Escadrons de %{fleet}",
          "overview": "Présentation de l'escadron de %{fleet}",
          "members": "Membres de l'escadron de %{fleet}",
          "create": {
            "details": "Créer un escadron - %{fleet}",
            "appearance": "Apparence de l'escadron - %{fleet}",
            "discord": "Discord de l'escadron - %{fleet}"
          },
          "edit": {
            "details": "Modifier l'escadron - %{fleet}",
            "appearance": "Apparence de l'escadron - %{fleet}",
            "discord": "Discord de l'escadron - %{fleet}"
          }
        },
        "stats": "Statistiques sur %{fleet}",
        "blueprints": "Plans de %{fleet}",
        "logistics": {
          "index": "%{fleet} Logistics",
          "inventories": "%{fleet} Inventories",
          "transfers": "Transferts de %{fleet}"
        },
        "missions": {
          "index": "Missions de %{fleet}",
          "create": "Créer une mission - %{fleet}",
          "edit": {
            "details": "Modifier la mission - %{fleet}",
            "teams": "Modifier les équipes & places - %{fleet}"
          },
          "show": "Mission de %{fleet}"
        },
        "events": {
          "index": "Événements de %{fleet}",
          "calendar": "Calendrier de %{fleet}",
          "create": "Créer un événement - %{fleet}",
          "edit": {
            "details": "Modifier l'événement - %{fleet}",
            "schedule": "Modifier la planification - %{fleet}",
            "signup": "Modifier les inscriptions - %{fleet}",
            "teams": "Modifier les équipes & places - %{fleet}"
          },
          "show": "Événement de %{fleet}",
          "payouts": "Répartition de l'événement %{fleet}"
        },
        "tours": {
          "index": "Expéditions de %{fleet}",
          "create": "Créer une expédition - %{fleet}",
          "show": "Expédition de %{fleet}"
        },
        "settings": {
          "index": "Paramètres de %{fleet}",
          "fleet": "Paramètres de %{fleet}",
          "rsi": "%{fleet} – ID de flotte et RSI",
          "membership": "Adhésion à %{fleet}",
          "roles": "Rôles de %{fleet}",
          "squadrons": "Escadrons de %{fleet}",
          "allies": "Alliés de %{fleet}",
          "notifications": "Paramètres de notification de %{fleet}",
          "discord": "Paramètres Discord de %{fleet}",
          "calendar": "Paramètres de calendrier de %{fleet}",
          "features": "Fonctionnalités de %{fleet}",
          "contracts": "Réglages des contrats de %{fleet}"
        },
        "contracts": {
          "index": "Contrats",
          "create": "Créer un contrat",
          "edit": "Modifier le contrat",
          "show": "Contrat",
          "payouts": "%{fleet} Paiements du contrat"
        },
        "directory": "Annuaire des flottes"
      },
      "roadmap": {
        "index": "Feuille de route",
        "ships": "Roadmap vaisseaux",
        "changes": "Changement Roadmap"
      },
      "settings": {
        "index": "Paramètres du profil",
        "profile": "Paramètres du profil",
        "account": "Compte",
        "hangar": "Paramètres de Hangar",
        "privacy": "Paramètres de confidentialité",
        "features": "Indicateurs de fonctionnalités",
        "connections": "Connexions",
        "oauthApplications": "Applications OAuth",
        "notifications": "Paramètres de notification",
        "calendar": "Abonnement au calendrier",
        "donations": "Dons",
        "security": "Sécurité du Compte",
        "twoFactor": {
          "enable": "Activer l'authentification à deux étapes",
          "disable": "Désactiver l'authentification en deux étapes",
          "backupCodes": "Générer des codes de sauvegarde"
        },
        "friends": "Amis"
      },
      "compare": {
        "ships": "Comparer les vaisseaux"
      },
      "notFound": "404",
      "tools": {
        "index": "Outils",
        "travelTimes": "Temps de Voyage",
        "cargoGrids": "Grilles de cargaison",
        "tradeRoutes": "Routes commerciales",
        "tours": {
          "index": "Expéditions",
          "add": "Créer une expédition",
          "show": "%{tour}",
          "join": "Rejoindre l'expédition"
        }
      },
      "impressum": "Mentions légales",
      "support": "Soutenir",
      "share": "Partager",
      "privacyPolicy": "Politique de confidentialité",
      "cookiePolicy": "Politique relative aux cookies",
      "visualTests": {
        "blueprints": "Plans - Tests Visuels",
        "index": "Tests Visuels",
        "panels": "Panneaux - Tests Visuels",
        "buttons": "Boutons - Tests Visuels",
        "events": "Événements",
        "typography": "Typographie - Tests visuels",
        "forms": "Formulaires - Tests visuels",
        "tables": "Tableaux - Tests Visuels",
        "lists": "Listes - Tests visuels",
        "metrics": "Métriques - Tests visuels",
        "states": "États - Tests visuels",
        "notifications": "Notifications - Tests Visuels",
        "syncModal": "Modale Sync - Tests Visuels",
        "overlays": "Superpositions - Tests Visuels",
        "installPrompt": "Invite d'installation - Tests Visuels",
        "supportHint": "Indicateur de soutien - Tests Visuels",
        "media": "Médias - Tests Visuels",
        "charts": "Graphiques - Tests Visuels",
        "themes": "Thèmes - Tests Visuels",
        "alerts": "Alertes - Tests visuels",
        "verifiedBadges": "Badges de vérification - Tests visuels",
        "chips": "Chips - Tests Visuels",
        "squadrons": "Escadrons - Tests Visuels",
        "notificationCenter": "Centre de notifications - Tests Visuels"
      },
      "admin": {
        "locations": {
          "index": "Lieux",
          "show": "%{location}"
        },
        "blueprints": {
          "index": "Plans",
          "show": "%{blueprint}"
        },
        "missions": {
          "index": "Missions",
          "show": "%{mission}"
        },
        "models": {
          "index": "Modèles",
          "new": "Nouveau Modèle",
          "edit": {
            "index": "Modifier %{manufacturer} %{model}",
            "metrics": "Modifier les métriques de %{manufacturer} %{model}",
            "prices": "Modifier les prix de %{manufacturer} %{model}",
            "fleetchart": "Modifier les images du Fleetchart de %{manufacturer} %{model}",
            "positions": "Modifier les postes d'équipage de %{manufacturer} %{model}",
            "hardpoints": "Modifier les points d'attache de %{manufacturer} %{model}",
            "cargoAndFuel": "Modifier le carburant de %{manufacturer} %{model}",
            "cargoHolds": "Modifier les soutes de %{manufacturer} %{model}",
            "docks": "Modifier les quais de %{manufacturer} %{model}",
            "modules": "Modifier les modules de %{manufacturer} %{model}",
            "paints": "Modifier les peintures de %{manufacturer} %{model}",
            "images": "Modifier les images de %{manufacturer} %{model}",
            "videos": "Modifier les vidéos de %{manufacturer} %{model}",
            "loaners": "Modifier les prêts de %{manufacturer} %{model}",
            "snubCrafts": "Modifier les Snub Crafts de %{manufacturer} %{model}",
            "upgrades": "Modifier les améliorations de %{manufacturer} %{model}",
            "packages": "Modifier les paquets de %{manufacturer} %{model}",
            "history": "Modifier l'historique de %{manufacturer} %{model}"
          }
        },
        "components": {
          "index": "Composants",
          "new": "Nouveau Composant",
          "edit": {
            "index": "Éditer le Composant",
            "prices": "Éditer les Prix du Composant",
            "history": "Modifier l'historique du composant"
          }
        },
        "manufacturers": {
          "index": "Fabricants",
          "new": "Nouveau Fabricant",
          "edit": {
            "index": "Éditer le Fabricant"
          }
        },
        "announcements": {
          "index": "Annonces",
          "new": "Nouvelle annonce",
          "edit": "Modifier l'annonce",
          "show": "Annonce"
        },
        "supporterContributions": {
          "index": "Contributions des soutiens",
          "new": "Nouvelle contribution de soutien",
          "edit": "Modifier la contribution de soutien"
        },
        "fundingGoals": {
          "index": "Objectifs de financement",
          "new": "Nouvel objectif de financement",
          "edit": "Modifier l'objectif de financement"
        },
        "users": {
          "index": "Utilisateurs",
          "edit": "Éditer l'Utilisateur",
          "inventories": "Inventaires de l'utilisateur",
          "inventory": "Inventaire de l'utilisateur",
          "inventoryItem": "Entrée d'inventaire",
          "fleets": "Flottes de l'utilisateur",
          "supporterContributions": "Contributions du soutien"
        },
        "vehicles": {
          "index": "Véhicules",
          "edit": "Éditer le Véhicule"
        },
        "admins": {
          "index": "Administrateurs",
          "new": "Nouvel Admin",
          "edit": "Éditer l'Admin"
        },
        "fleets": {
          "index": "Flottes",
          "edit": "Éditer la Flotte",
          "members": "Membres de la flotte",
          "memberEdit": "Modifier le membre de la flotte",
          "history": "Historique de la flotte",
          "roles": "Rôles de la flotte",
          "role": "Rôle de la flotte",
          "inventories": "Inventaires de la flotte",
          "inventory": "Inventaire de la flotte",
          "inventoryItem": "Entrée d'inventaire"
        },
        "oauthApplications": {
          "index": "Applications OAuth",
          "new": "Nouvelle application OAuth",
          "edit": "Modifier l'application OAuth"
        },
        "features": {
          "index": "Indicateurs de fonctionnalités",
          "show": "Détails de la fonctionnalité"
        },
        "images": {
          "index": "Images"
        },
        "notifications": {
          "index": "Notifications"
        },
        "maintenance": {
          "index": "Maintenance",
          "pghero": "PgHero",
          "features": "Fonctionnalités",
          "flipper": "Flipper UI",
          "workers": "Workers",
          "tasks": "Tâches",
          "imports": "Imports",
          "importDetail": "Détail de l'import",
          "rsiApiStatus": "Statut de l'API RSI",
          "buildCompare": "Comparer les builds"
        },
        "modelPaints": {
          "index": "Peintures de Modèles",
          "edit": "Éditer la Peinture du Modèle"
        },
        "modelModules": {
          "index": "Modules de Modèles",
          "edit": {
            "index": "Éditer %{name} Données de Base",
            "models": "Éditer %{name} Modèles",
            "prices": "Éditer %{name} Prix",
            "hardpoints": "Modifier les Points de Montage de %{name}",
            "docks": "Modifier les quais de %{name}",
            "cargoHolds": "Modifier les soutes de %{name}",
            "history": "Modifier l'historique du module"
          }
        },
        "unlistedModels": {
          "index": "Vaisseaux non listés"
        },
        "modelModulePackages": {
          "index": "Paquets de Modules de Modèles"
        },
        "commodities": {
          "index": "Commodities",
          "new": "New Commodity",
          "edit": {
            "index": "Edit Commodity"
          }
        },
        "equipment": {
          "index": "Equipment",
          "new": "New Equipment",
          "edit": {
            "index": "Edit Equipment",
            "prices": "Edit Equipment Prices"
          }
        },
        "visualTests": {
          "index": "Tests Visuels",
          "notifications": "Notifications - Tests Visuels"
        }
      },
      "notifications": "Notifications",
      "component": "%{name}",
      "commodity": "%{name}",
      "commodities": {
        "index": "Marchandises"
      },
      "components": {
        "index": "Composants"
      },
      "blueprints": {
        "index": "Plans"
      },
      "missions": {
        "index": "Missions"
      },
      "equipment": {
        "index": "Équipement"
      },
      "equipmentItem": "%{name}"
    }
  }
}
